<div class="spinner__container" [ngClass]="containerClass">
  <svg class="spinner__icon" viewBox="25 25 50 50">
    <circle
      class="spinner__path"
      cx="50"
      cy="50"
      r="20"
      fill="none"
      stroke-width="3"
      stroke-miterlimit="10"
    />
  </svg>
</div>
